import React from 'react';
import Card from './Card';
import Content from './Content';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
import LottieAnimation from '../assets/Animations/Lottie';
import animationData from '../assets/Animations/dancing-burger';
import Mono from '../assets/category/ghost.jpeg';
import Archi from '../assets/category/charminar.jpeg';
import Nat from '../assets/category/mush1.jpg';
import Land from '../assets/category/nature.jpeg';
import Peo from '../assets/category/target.jpeg';
import Stre from '../assets/category/bhilwara.jpeg';
import Sil from '../assets/category/horizon.jpeg';



class Category extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            show: true,
            selected: "",
            categories: ["Monochrome", "Nature", "Landscape", "People","Street", "Silhouette", "Architecture"],
            images: [{
                    "Monochrome": "ghost.jpeg",
                    "id": 0,
                    "img": Mono
                },
                {
                    "Nature": "mush1.jpg",
                    "id": 1,
                    "img": Nat
                }, 
                {
                    "Landscape": "nature.jpeg",
                    "id": 2,
                    "img": Land
                }, 
                {
                    "People": "target.jpeg",
                    "id": 3,
                    "img": Peo
                },
                {
                    "Street": "bhilwara.jpeg",
                    "id": 4,
                    "img": Stre
                }, 
                {
                    "Silhouette": "horizon.jpeg",
                    "id": 5,
                    "img": Sil
                },
                {
                    "Architecture": "charminar.jpeg",
                    "id": 6,
                    "img": Archi
                }]
        }
        this.setContent = this.setContent.bind(this);

        
    }

    setContent(cat){
        this.setState({
            show: false,
            selected: cat
        });
    }
    componentDidMount(){
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 2000);
    }
    componentDidUpdate(){   
        
        window.onpopstate = e => {
           this.setState({
               show: true,
               selected: ""
               
           });
        }
        window.location.pathname.replace("#/");
        
      }
    
    

    

    render(){
        const {show, selected, categories, images} = this.state;
        return (
            this.state.isLoading ? <LottieAnimation lotti={animationData} height={'auto'} width={'90%'} isloop={true}/>
            :
            <Router>
                <div>
                    {this.state.show ? 
                        <div className="row">
                            {
                                categories.map((category, index) => {
                                    return (
                                        <div key={index} className="column" onClick={(e) => this.setContent({category})}>
                                            {
                                                <Link to={`/categories/${category}`}>
                                                    <Card image={images[index].img} detail={`${category}`} />
                                                </Link>
                                            }
                                        </div>
                                    );
                                })
                            }
                            
                        </div>
                        :
                        <div style={{"display": "none"}}></div>
                    }
                        
                    </div>
                    <Switch>
                        {categories.map((category, index) => {
                            return (
                                <Route key={index} path={`/categories/${category}`} >
                                    <div id="content" onLoad={(e) => this.setState({show: false, selected: {category}})}>
                                        <Content cat={category} />
                                    </div>
                                </Route>
                            );
                        })}
                    </Switch>
            </Router>
            
        );
    }
}


export default Category;